import { render, staticRenderFns } from "./character_bio.vue?vue&type=template&id=dde91b50"
import script from "./character_bio.vue?vue&type=script&lang=ts"
export * from "./character_bio.vue?vue&type=script&lang=ts"
import style0 from "./character_bio.vue?vue&type=style&index=0&id=dde91b50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports